/* Product page behavior */
(function () {
  'use strict';

  function parseConfig(sectionRoot) {
    var sectionId = sectionRoot.dataset.sectionId;
    var configEl = document.getElementById('ProductConfig-' + sectionId);
    if (!configEl) return {};
    try {
      return JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      console.error('Unable to parse product configuration:', error);
      return {};
    }
  }

  function addBusinessDays(startDate, days) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var remaining = Math.max(0, days);
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      var weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) remaining -= 1;
    }
    return date;
  }

  function initDeliveryEstimate(sectionRoot) {
    sectionRoot.querySelectorAll('[data-delivery-estimate]').forEach(function (deliveryBox) {
      var output = deliveryBox.querySelector('[data-delivery-date]');
      if (!output) return;

      var minDays = Number.parseInt(deliveryBox.dataset.minDays, 10);
      var maxDays = Number.parseInt(deliveryBox.dataset.maxDays, 10);
      if (Number.isNaN(minDays)) minDays = 6;
      if (Number.isNaN(maxDays)) maxDays = 9;
      minDays = Math.max(0, minDays);
      maxDays = Math.max(minDays, maxDays);

      var now = new Date();
      var minimumDate = addBusinessDays(now, minDays);
      var maximumDate = addBusinessDays(now, maxDays);
      var locale = document.documentElement.lang || (window.Shopify && Shopify.locale) || 'en';
      var formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      });

      output.textContent = formatter.format(minimumDate) + ' – ' + formatter.format(maximumDate);
      output.setAttribute('aria-label', 'Estimated delivery between ' + formatter.format(minimumDate) + ' and ' + formatter.format(maximumDate));
    });
  }

  function initBuyNow(sectionRoot) {
    var form = sectionRoot.querySelector('form[action*="/cart/add"]');
    var button = sectionRoot.querySelector('[data-buy-now]');
    if (!form || !button || button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';

    button.addEventListener('click', async function () {
      if (button.disabled) return;

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        form.reportValidity();
        return;
      }

      var originalText = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Processing…';

      try {
        var formData = new FormData(form);
        var response = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!response.ok) {
          var errorData = await response.json().catch(function () { return {}; });
          throw new Error(errorData.description || errorData.message || 'Unable to add this item.');
        }

        window.location.assign(window.Shopify && Shopify.routes ? Shopify.routes.root + 'checkout' : '/checkout');
      } catch (error) {
        console.error('Buy it now failed:', error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
        window.alert(error.message || 'Unable to continue to checkout. Please try again.');
      }
    });
  }

  function initVariantSelector(sectionRoot, productConfig) {
    var productVariants = productConfig.variants || [];
    var selectedOptions = (productConfig.selectedOptions || []).slice();

    function findVariant() {
      return productVariants.find(function (variant) {
        return selectedOptions.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      var variantInput = sectionRoot.querySelector('[name="id"]');
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var addButton = sectionRoot.querySelector('[data-add-to-cart]');
      var buyButton = sectionRoot.querySelector('[data-buy-now]');
      if (addButton) {
        addButton.dataset.variantId = variant.id;
        addButton.textContent = variant.available ? 'Add To Cart' : 'Sold Out';
        addButton.disabled = !variant.available;
      }
      if (buyButton) buyButton.disabled = !variant.available;

      var priceElement = sectionRoot.querySelector('#sticky-product-price');
      if (priceElement && typeof variant.price === 'number') {
        var currency = productConfig.currency || 'USD';
        var locale = document.documentElement.lang || 'en';
        var money = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceElement.innerHTML = '<span class="sale-price">' + money.format(variant.price / 100) + '</span><span class="original">' + money.format(variant.compare_at_price / 100) + '</span>';
        } else {
          priceElement.textContent = money.format(variant.price / 100);
        }
      }
    }

    sectionRoot.querySelectorAll('.size-btn, .color-swatch-btn').forEach(function (button) {
      if (button.dataset.variantInitialized === 'true') return;
      button.dataset.variantInitialized = 'true';
      button.addEventListener('click', function () {
        var optionIndex = Number.parseInt(button.dataset.optionIndex, 10);
        selectedOptions[optionIndex] = button.dataset.value;
        var optionsContainer = button.closest('.size-options');
        if (optionsContainer) {
          optionsContainer.querySelectorAll('.size-btn, .color-swatch-btn').forEach(function (item) {
            item.classList.remove('active');
            item.setAttribute('aria-pressed', 'false');
          });
        }
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
        var group = button.closest('.variant-option-group');
        var label = group && group.querySelector('.selected-option-value');
        if (label) label.textContent = button.dataset.value;
        updateVariantUI(findVariant());
      });
    });
  }

  function initSizeChart(sectionRoot) {
    var triggers = sectionRoot.querySelectorAll('[data-size-chart-open]');

    triggers.forEach(function (trigger) {
      if (trigger.dataset.sizeChartInitialized === 'true') return;
      trigger.dataset.sizeChartInitialized = 'true';

      var modalId = trigger.getAttribute('data-size-chart-open');
      var modal = document.getElementById(modalId);
      if (!modal) return;

      var closeButtons = modal.querySelectorAll('[data-size-chart-close]');
      var dialog = modal.querySelector('.size-chart-modal__dialog');
      var lastFocusedElement = null;

      function getFocusableElements() {
        return Array.from(modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      }

      function openModal() {
        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('size-chart-modal-open');
        var closeButton = modal.querySelector('.size-chart-modal__close');
        if (closeButton) closeButton.focus();
      }

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('size-chart-modal-open');
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      }

      trigger.addEventListener('click', openModal);
      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;
        var focusable = getFocusableElements();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (dialog) {
        dialog.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    });
  }

  function initProductSection(sectionRoot) {
    if (!sectionRoot) return;
    var config = parseConfig(sectionRoot);
    initVariantSelector(sectionRoot, config);
    initBuyNow(sectionRoot);
    initDeliveryEstimate(sectionRoot);
    initSizeChart(sectionRoot);
  }

  function initAll() {
    document.querySelectorAll('[data-product-main]').forEach(initProductSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target.querySelector('[data-product-main]') || (event.target.matches && event.target.matches('[data-product-main]') ? event.target : null);
    initProductSection(sectionRoot);
  });
})();
